<template>
  <div :class="{ 'is--full-width-small': props._index === 0 }" class="section-dossiers">
    <SectionHeader
      v-if="props._index !== 0"
      label="Dossiers"
      :button-url="props.showButton ? '/dossiers' : undefined"
    />

    <Carousel v-if="state.items" class="carousel">
      <li
        v-for="(dossier, index) in state.items"
        :key="`slide_${(dossier as ICollectionTeaser).id}_${index}`"
        class="slide"
      >
        <TeaserPoster
          v-bind="dossier as ICollectionTeaser"
          tag="a"
          priority="low"
          loading="lazy"
          heading-size="title-xs"
          :renditions="renditions"
          aria-label-prefix="Dossier:"
          :analytics="{
            linkAnalyticsTag: `section-dossiers`,
          }"
        />
      </li>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import type { ICmsSectionDossiers } from '~~/types/_cms-types';
import useAdditionalTeasers from '~/composables/useAdditionalTeasers';
import useAdapter from '~/composables/useAdapter';
import type { ICollectionTeaser } from '~~/types/local_types';

const renditions = [
  {
    breakpoint: 'sm',
    size: 480,
    aspectRatio: '4x3',
  },
];

interface IProps extends ICmsSectionDossiers {
  _index?: number;
  showButton?: boolean;
  items?: ICollectionTeaser[];
}

interface IState {
  items?: ICollectionTeaser[];
}

const props = withDefaults(defineProps<IProps>(), {
  _index: 0,
  showButton: true,
  items: undefined,
});

const state = reactive<IState>({});
const { dossierTeaserAdapter } = useAdapter();

const getAdditionalItems = async () => {
  const manualDossiers = props.manualDossiers?.map((dossier) => dossier.dossiersId) || [];
  const manualDossiersIds = manualDossiers.map((dossier) => dossier?.id as number) || [];

  const additionalItems = await useAdditionalTeasers(
    `dossiersSection_${props._index}`,
    props,
    5,
    manualDossiersIds,
    '-adjust_time',
    'dossiers',
  );

  const all = [...manualDossiers, ...additionalItems];
  return all.map(dossierTeaserAdapter);
};

// component can also receive items from outside the component
state.items = props.items ? props.items : ((await getAdditionalItems()) as ICollectionTeaser[]);
</script>

<style scoped lang="postcss">
.carousel {
  margin: -4px 0; /*to show focus outline*/
}
.slide {
  position: relative;
  overflow: visible;
  margin: 4px 0; /*to show focus outline*/
  width: 80%;
  aspect-ratio: 4/3;

  @media (--md-viewport) {
    width: calc(100% / 3.5 - var(--carousel-track-gap));
  }

  > * {
    width: 100%;
  }
}
</style>
